import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_passengers';
export const route = 'checkout_passengers/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/PassengersPage')));